// extracted by mini-css-extract-plugin
module.exports = {"learner-name":"DeleteLearerRecord_learner-name__3dsbu","row--pipe-separated":"DeleteLearerRecord_row--pipe-separated__15VMW","question":"DeleteLearerRecord_question__2wE9-"};